// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Q_uf","largestCol":"styles_largestCol__2zNyF","smallestCol":"styles_smallestCol__2ZuQo"};